import { useState } from 'react';
import { useRequestMagicLink } from '../lib/auth.js';

export function LoginPage(): JSX.Element {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const req = useRequestMagicLink();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await req.mutateAsync(email);
    setSubmitted(true);
  };

  return (
    <div className="mx-auto max-w-md rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
      <h1 className="text-xl font-semibold">Sign in</h1>
      <p className="mt-1 text-sm text-slate-600">Enter your email and we will send you a single-use sign-in link.</p>
      {submitted ? (
        <p data-testid="login-sent" className="mt-6 rounded bg-slate-50 p-4 text-sm text-slate-700">
          If that email is registered, a sign-in link is on its way. The link is valid for 15 minutes.
        </p>
      ) : (
        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <label className="block text-sm font-medium text-slate-700">
            Email
            <input
              type="email"
              required
              autoFocus
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 block w-full rounded border border-slate-300 px-3 py-2 text-sm shadow-sm focus:border-slate-500 focus:outline-none focus:ring-1 focus:ring-slate-500"
              placeholder="dealer@example.com"
              data-testid="login-email"
            />
          </label>
          <button
            type="submit"
            disabled={req.isPending || !email}
            className="w-full rounded bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800 disabled:cursor-not-allowed disabled:bg-slate-400"
            data-testid="login-submit"
          >
            {req.isPending ? 'Sending...' : 'Send sign-in link'}
          </button>
        </form>
      )}
    </div>
  );
}
